(function () {
  'use strict';

  if (window.wsArrowCirclesLoaded) return;
  window.wsArrowCirclesLoaded = true;

  const instances = new Map();

  function initialize(section) {
    if (instances.has(section)) return;

    const track = section.querySelector(
      '[data-ws-collection-track]'
    );

    if (!track) return;

    const previousButton = section.querySelector(
      '[data-ws-collection-prev]'
    );

    const nextButton = section.querySelector(
      '[data-ws-collection-next]'
    );

    const controller = new AbortController();
    const signal = controller.signal;

    function getStep() {
      const items = track.querySelectorAll(
        '.women-spot-circle-item'
      );

      if (items.length > 1) {
        return (
          items[1].getBoundingClientRect().left -
          items[0].getBoundingClientRect().left
        );
      }

      return items[0]?.getBoundingClientRect().width ||
        track.clientWidth;
    }

    function updateButtons() {
      const maximumScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      if (previousButton) {
        previousButton.disabled = track.scrollLeft <= 2;
      }

      if (nextButton) {
        nextButton.disabled =
          maximumScroll <= 2 ||
          track.scrollLeft >= maximumScroll - 2;
      }
    }

    function move(direction) {
      track.scrollBy({
        left: direction * getStep(),
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches ? 'auto' : 'smooth'
      });
    }

    previousButton?.addEventListener(
      'click',
      function () {
        move(-1);
      },
      { signal }
    );

    nextButton?.addEventListener(
      'click',
      function () {
        move(1);
      },
      { signal }
    );

    track.addEventListener(
      'scroll',
      updateButtons,
      { passive: true, signal }
    );

    track.addEventListener(
      'keydown',
      function (event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          move(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          move(1);
        }
      },
      { signal }
    );

    window.addEventListener(
      'resize',
      updateButtons,
      { signal }
    );

    let observer;

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(updateButtons);
      observer.observe(track);
    }

    instances.set(section, function () {
      controller.abort();
      observer?.disconnect();
      instances.delete(section);
    });

    updateButtons();
  }

  function initializeAll(root = document) {
    if (root.matches?.('.women-spot-collections')) {
      initialize(root);
    }

    root.querySelectorAll?.('.women-spot-collections')
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAll();
      },
      { once: true }
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      for (const [section, cleanup] of instances) {
        if (
          section === event.target ||
          event.target.contains(section)
        ) {
          cleanup();
        }
      }
    }
  );
})();